import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initSentry } from "./config/sentry";

// Inicializace Sentry (pokud je nakonfigurován)
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
